module.exports = __webpack_public_path__ + "img/spidey.87f9d91a.png";